
import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { AddsubcategoryComponent } from './addsubcategory/addsubcategory.component';
import { NgbdSortableHeader, SortEvent } from 'src/app/_directives/sortable.directive';
import { Subcategory } from 'src/app/_models/Subcategory';
import { SubcategoryService } from 'src/app/_services/subcategory.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { Router } from '@angular/router';
import { ToastService } from 'src/app/_services/toastservice';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-subcategory',
  templateUrl: './subcategory.component.html',
  providers: []
})
export class SubcategoryComponent implements OnInit {
  data$: Observable<Subcategory[]>;
  oldData: Subcategory[];
  total$: Observable<number>;
  loading$: Observable<boolean>;
  private selectedBrand;
  locationSubscription: Subscription;
  submit: boolean;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  constructor(public service: SubcategoryService,
    public ls: LocalStorageService,
    public ts: ToastService,
    public tss: ToastrService,
    public router: Router) {

    this.selectedBrand = this.ls.getSelectedUser().userID;
    this.loading$ = service.loading$;
    this.submit = false;
  }

  ngOnInit() {
    this.getData();
  }

  getData() {
    this.service.getAllData();
    this.data$ = this.service.data$;
    this.total$ = this.service.total$;
    this.loading$ = this.service.loading$;
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.service.sortColumn = column;
    this.service.sortDirection = direction;
  }

  Edit(subcategory) {
    this.router.navigate(["admin/subcategory/edit", subcategory]);
  }

  Delete(obj) {
    if (confirm("Are you sure to delete? ")) {
      this.service.delete(obj).subscribe((res: any) => {
        if (res != 0) {
          this.ts.showSuccess("Success", "Record deleted successfully.")
          this.getData();
        }
        else {
          this.ts.showError("Error", "Failed to delete record.");
        }
      }, error => {
        this.ts.showError("Error", "Failed to delete record.")
      });
    }
  }
}
